import React from 'react';
import { Typography } from '@fiverr-private/typography';
import pathfinder from '@fiverr-private/pathfinder';
import { appTranslate } from '../../i18n';
import { LINK_QUERY_PARAMS } from './Disclaimer.constants';
import { DisclaimerLink } from './DisclaimerLink';

export const Disclaimer = () => {
    const termsOfServicesLink = pathfinder('tos', undefined, { query: LINK_QUERY_PARAMS });
    const privacyPolicyLink = pathfinder('privacy_policy', undefined, { query: LINK_QUERY_PARAMS });

    return (
        <Typography marginTop="4" color="grey_900" size="b_xs">
            {appTranslate('identification.disclaimer', {
                templates: {
                    tos_link: (text?: string) => <DisclaimerLink href={termsOfServicesLink}>{text}</DisclaimerLink>,
                    privacy_link: (text?: string) => <DisclaimerLink href={privacyPolicyLink}>{text}</DisclaimerLink>,
                },
            })}
        </Typography>
    );
};
